module.exports = __webpack_public_path__ + "img/visitor.e31425a3.svg";